<template>
    <form
        @submit.prevent="isUploaded ? SubmitConfirmDetails(): submitApplication()"
        class="grid gap-3"
    >
        <section v-if="(params?.personalInfo.name || params?.personalInfo?.firstName) && params.personalInfo.addressAsPerId.line1" class="grid gap-1">
            <p class="label-text-medium">Address as per <span v-if="addressType">{{ addressType }}</span><span v-else>KYC</span> Document</p>
            <article class="grid gap-3 border border-gray-300 p-3 rounded-xl bg-white">
                <div v-if="params?.personalInfo?.name || params?.personalInfo?.firstName" class="grid gap-1">
                    <p class="secondary-headingColor-text-blogger font-semibold">
                        Your Name
                    </p>
                    <p v-if="params.personalInfo.name" class="secondary-heading-text">
                        {{ params?.personalInfo?.name }}
                    </p>
                    <p v-else class="secondary-heading-text">
                        {{ params?.personalInfo?.firstName }} {{ params?.personalInfo?.middleName }} {{ params?.personalInfo?.lastName }}
                    </p>
                </div>
                <div v-if="params.personalInfo.addressAsPerId.line1" class="grid gap-1">
                    <p class="secondary-headingColor-text-blogger font-semibold">
                        Personal Address
                    </p>
                    <p class="secondary-heading-text">
                        {{ params.personalInfo.addressAsPerId.line1 }} {{ params.personalInfo.addressAsPerId.line2 }} {{ params.personalInfo.addressAsPerId.state }} {{ params.personalInfo.addressAsPerId.pincode }}
                    </p>
                </div>
            </article>
        </section>
        <fieldset v-if="(params?.personalInfo.name || params?.personalInfo?.firstName) && params.personalInfo.addressAsPerId.line1"
            class="flex gap-2 items-center secondary-heading-text"
        >
            <span class="p-px">
            <input v-model="checked" type="checkbox" name="consent" id="consent" class="text-primary" />
            </span>
            <label for="consent">
                Communication address is same as per <span v-if="addressType">{{ addressType }}</span><span v-else>KYC</span> Document.
            </label>
        </fieldset>
        <section class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
            <div class="grid gap-1">
                <label class="label-text-medium" for="current residential">
                    Communication Address
                </label>
                <input
                    type="text"
                    name="current residential"
                    id="current residential"
                    class="input"
                    placeholder="Enter Your Communication Address"
                    v-model.trim="params.personalInfo.currentAddress"
                    required
                    :disabled="checked && params.personalInfo.currentAddress"
                />
            </div>
        </section>
        <section class="grid grid-cols-2 gap-4 md:gap-8">
            <div class="grid gap-1">
                <label class="label-text-medium" for="pincode">
                    Pincode
                </label>
                <input
                    type="text"
                    inputmode="numeric"
                    name="Pincode"
                    id="pincode"
                    class="input"
                    placeholder="Enter Pincode"
                    maxlength="6"
                    minlength="6"
                    pattern="[0-9]{6}"
                    v-model.trim="params.personalInfo.currentAddressPinCode"
                    required
                    @keypress="isNumber"
                    :disabled="checked && checkPinCodeFromAPi"
                />
            </div>
            <div class="grid gap-1">
                <label for="city" class="label-text-medium">City</label>
                <input
                    type="text"
                    name="city"
                    id="city"
                    class="input"
                    placeholder="Enter City"
                    minlength="1"
                    v-model.trim="params.personalInfo.city"
                    required
                    :disabled="checkCityStateFromAPi"
                />
            </div>
        </section>
        <section class="grid grid-cols-1 gap-4 md:gap-8">
            <div class="grid gap-1">
                <p class="label-text-medium">State</p>
                <input
                    type="text"
                    name="State"
                    id="state"
                    class="input"
                    placeholder="Enter State"
                    minlength="1"
                    v-model.trim="params.personalInfo.state"
                    required
                    :disabled="checkCityStateFromAPi"
                />
            </div>
        </section>
        <section v-if="!checked && !isUploaded" class="grid gap-1">
            <p class="label-text-medium">Upload Address Proof (Optional)</p>
            <div @click.prevent="requestMedia()" class="flex justify-between px-4 h-16 items-center rounded-lg shadow-cardShadow w-full bg-white cursor-pointer">
                <p class="label-text-myriad">Upload Proof</p>
                <img src="../assets/upload-static-icon.svg" alt="" width="24">
            </div>
            <p class="secondary-heading-text pt-2">
                Please upload your Communication Address in PDF or Image format only. <br/> If your Communication Address PDF is password-protected, kindly enter the password to proceed.
            </p>
        </section>
        <section class="grid gap-1" v-if="!checked && isUploaded">
            <p class="label-text-medium">Upload Address Proof</p>
            <article class="flex justify-between pr-4 h-16 items-center rounded-lg shadow-cardShadow w-full bg-white">
                <div class="flex items-center">
                    <div class="w-16 h-16">
                        <Vue3Lottie :animationData="AutoTick" :speed="1" :loop="true" />
                    </div>
                    <span>
                        <p class="label-text-medium whitespace-nowrap truncate w-32">{{ storageDoc?.name }}</p>
                        <p class="secondary-heading-text-blogger">File Uploaded</p>
                    </span>
                </div>
                <div>
                    <p @click.prevent="isUploaded = false; isPdfPasswordProtected = false; pdfPasswordValue = undefined" class="underline font-blogger text-xs text-primary font-semibold">
                        Remove
                    </p>
                </div>
            </article>
            <article v-if="isPdfPasswordProtected" class="grid gap-1 pt-2">
                <p class="label-text-medium">Password</p>
                <input
                    type="text"
                    name="password"
                    id="password"
                    class="input rounded-lg shadow-cardShadow"
                    placeholder="Enter Password"
                    v-model="pdfPasswordValue"
                    required
                />
                <p class="secondary-heading-text">
                    This Communication address PDF is password-protected. Please enter the password below to upload and continue.
                </p>
            </article>
        </section>
        <span class="grid pb-20"></span>
        <section class="footer">
            <custom-button
                type="submit"
                variant="primary"
                class="btn--normal btn"
                :disabled="isDisabled"
            >
                Submit
            </custom-button>
        </section>
        <error-message-popup
            v-if="errorPopupMessage"
            @close-modal="errorPopupMessage = undefined"
            :errorPopupMessage="errorPopupMessage"
            routeLink="Current Address"
            actionButtonText="Ok"
            :defaultContinueAnyways="false"
            @continue-anyways="errorPopupMessage = undefined"
        />
        <!-- Spin Loader -->
        <spin-loader :spinLoading="isSpinLoading"/>
    </form>
  </template>
  <script>
  import { mapGetters } from 'vuex';
  import CustomButton from '../components/CustomButton.vue';
  import ErrorMessagePopup from "../components/ErrorMessagePopup.vue";
  import SpinLoader from '../components/spinLoader.vue';
  import AutoTick from '../assets/animation/auto-tick.json';

  export default {
    name: 'Current Address',
    components: {
      CustomButton,
      SpinLoader,
      ErrorMessagePopup
    },
    computed: {
      ...mapGetters(['applicationId']),
    },
    data() {
      return {
        isSpinLoading: undefined,
        isDisabled: false,
        checked: false,
        AutoTick,
        params: {
            personalInfo: {
                name: undefined,
                firstName: undefined,
                middleName: undefined,
                lastName: undefined,
                addressAsPerId: {
                    pincode: undefined,
                    state: undefined,
                    city: undefined,
                    line1: undefined,
                    line2: undefined,
                },
                currentAddress: undefined,
                currentAddressPinCode: undefined,
            },
        },
        checkPinCodeFromAPi: undefined,
        errorPopupMessage: undefined,
        isUploaded: undefined,
        storageDoc: undefined,
        pdfPasswordValue: undefined,
        isPdfPasswordProtected: undefined,
        queryData: this.$route.query,
        addressType: undefined,
        checkCityStateFromAPi: undefined,
      };
    },
    mounted() {
      this.init();
    },
    watch: {
        checked(newVal) {
            if (newVal) {
                // Checkbox is checked: Update currentAddress
                const { line1, city, state, pincode } = this.params.personalInfo.addressAsPerId;
                this.params.personalInfo.currentAddress = [line1, city, state, pincode].filter(Boolean).join(' ');
                const pinCode = this.$filters.extractPinCode(line1);
                this.params.personalInfo.currentAddressPinCode = pincode || pinCode;
                this.params.personalInfo.city = city;
                this.params.personalInfo.state = state;
            } else {
                this.params.personalInfo.currentAddress = undefined;
                this.params.personalInfo.currentAddressPinCode = undefined;
                this.params.personalInfo.city = undefined;
                this.params.personalInfo.state = undefined;
                this.pdfPasswordValue = undefined;
                this.storageDoc = undefined;
            }
        },
        'params.personalInfo.currentAddressPinCode': function getPincode() {
            if (
                this.params.personalInfo.currentAddressPinCode &&
                this.params.personalInfo.currentAddressPinCode.length === 6 &&
                this.params.personalInfo.currentAddressPinCode.match(/[0-9]{6}/)
            ) {
                this.getPincode(this.params.personalInfo.currentAddressPinCode)
                .then((result) => {
                    this.params.personalInfo.state = result.state;
                    this.params.personalInfo.city = result.city;
                    if (result.state && result.city) {
                        this.checkCityStateFromAPi = true;
                    } else {
                        this.checkCityStateFromAPi = false;
                    }
                })
                .catch(() => {
                    this.params.personalInfo.city = undefined;
                    this.params.personalInfo.state = undefined;
                });
            } else if (this.params.personalInfo.currentAddressPinCode.length < 6) {
                this.params.personalInfo.city = undefined;
                this.params.personalInfo.state = undefined;
            }
        },
    },
    methods: {
        init() {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_PERSONAL_ADDRESS_LANDED);
            if (this.queryData.skipOfferScreen || this.queryData.isKycEnabled) {
                this.getApplicationAddress();
            } else {
                this.getAadharAddress();
            }
        },
        getApplicationAddress() {
            const params = {
                applicationId: this.applicationId
            };
            this.$store
            .dispatch('applicationAddress', params)
            .then((result) => {
                this.addressType = result?.addressType;
                this.params.personalInfo.name = result?.name;
                this.params.personalInfo.addressAsPerId.pincode = result?.address?.pincode;
                this.params.personalInfo.addressAsPerId.state = result?.address?.state;
                this.params.personalInfo.addressAsPerId.city = result?.address?.city;
                this.params.personalInfo.addressAsPerId.line1 = result?.address?.line1;
                this.params.personalInfo.addressAsPerId.line2 = result?.address?.line2;
                if (result?.address?.pincode?.length === 6) {
                    this.checkPinCodeFromAPi = true;
                } else {
                    this.checkPinCodeFromAPi = false;
                }
                if (result) {
                    this.checked = true;
                } else {
                    this.checked = false;
                }
            })
            .catch(() => { });
        },
        getAadharAddress() {
            const params = {
                applicationId: this.applicationId
            };
            this.$store
            .dispatch('aadharAddress', params)
            .then((result) => {
                this.params.personalInfo.firstName = result.personalInfo?.firstName;
                this.params.personalInfo.middleName = result.personalInfo?.middleName;
                this.params.personalInfo.lastName = result.personalInfo?.lastName;
                this.params.personalInfo.addressAsPerId.pincode = result.personalInfo?.addressAsPerId.pincode;
                this.params.personalInfo.addressAsPerId.state = result.personalInfo?.addressAsPerId.state;
                this.params.personalInfo.addressAsPerId.city = result.personalInfo?.addressAsPerId.city;
                this.params.personalInfo.addressAsPerId.line1 = result.personalInfo?.addressAsPerId.line1;
                this.checked = true;
                if (result.personalInfo?.addressAsPerId.pincode?.length === 6) {
                    this.checkPinCodeFromAPi = true;
                } else {
                    this.checkPinCodeFromAPi = false;
                }
            })
            .catch(() => { });
        },
        submitApplication() {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_PERSONAL_ADDRESS_CONFIRM_DETAILS_CLICKED, {
                [this.$mixpanelPayload.M_CODE]: 'true',
            });
            this.$registerProperties({
                platform: 'web',
                m_code: 'gpay',
            });
            this.isSpinLoading = true;
            const params = {
                applicationId: this.applicationId,
                body: {
                    aadharAddress: this.params.personalInfo.addressAsPerId.line1 + this.params.personalInfo.addressAsPerId.line2 + this.params.personalInfo.addressAsPerId.city + this.params.personalInfo.addressAsPerId.state + this.params.personalInfo.addressAsPerId.pincode,
                    currentAddress: this.params.personalInfo.currentAddress,
                    currentAddressPincode: this.params.personalInfo.currentAddressPinCode,
                    currentAddressSame: false,
                }
            };
            this.$store
            .dispatch('currentAddress', params)
            .then(() => {
                this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_CURRENT_ADDRESS_API, {
                    [this.$mixpanelPayload.RESPONSE]: 'success',
                });
                this.isDisabled = true;
                this.isSpinLoading = false;
                this.$router.push({
                    name: 'Pre Approval Step 3',
                });
            })
            .catch((err) => {
                this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_CURRENT_ADDRESS_API, {
                    [this.$mixpanelPayload.ERROR_REASON]: err.message,
                });
                this.isDisabled = false;
                this.isSpinLoading = false;
            });
        },
        isNumber(evt) {
            const event = evt || window.event;
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        getPincode(pincode) {
            return new Promise((resolve, reject) => {
                this.$store
                .dispatch('getPincode', pincode)
                .then((result) => {
                    resolve(result);
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
        requestMedia() {
            const mediaRequest = {
                allowedMimeTypes: ["image/jpeg", "application/pdf"],
            };
            window.microapps.requestMedia(mediaRequest).then(response => {
                this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_REQUEST_MEDIA, {
                    [this.$mixpanelPayload.RESPONSE]: 'success',
                });
                const fileByteArray = this.base64ToByteArray(response.bytes);
                const blob = new Blob([fileByteArray], { type: response.mimeType });
                this.openFilePicker(blob);
            })
            .catch((err) => {
                this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_REQUEST_MEDIA, {
                    [this.$mixpanelPayload.RESPONSE]: err,
                });
            });
        },
        base64ToByteArray(base64String) {
            const binaryString = window.atob(base64String);
            const byteArray = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i += 1) {
                byteArray[i] = binaryString.charCodeAt(i);
            }
            return byteArray;
        },
        getFileExtension(blob) {
            const splitName = blob.type.split('/');
            return splitName[splitName.length - 1];
        },
        async openFilePicker(blob) {
            const fileExtension = this.getFileExtension(blob);
            const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\..*$/, '');
            const fileName = `document_${timestamp}.${fileExtension}`;
            // Create a File object multipart
            const multipartFile = new File([blob], fileName, {
                lastModified: Date.now(),
                type: blob.type,
            });
            this.storageDoc = multipartFile;
            this.isUploaded = true;
            if (blob.type === "application/pdf") {
                const locked = await this.$store.dispatch("checkPdfPasswordProtected", multipartFile);
                if (locked) {
                    this.isSpinLoading = false;
                    this.isPdfPasswordProtected = true;
                }
            }
        },
        readFile(multiFile, params) {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('file', multiFile);
                formData.append('jsonPayload', JSON.stringify(params));
                this.$store
                .dispatch('v3ApplicationAddressProof', {
                    formData,
                    applicationId: this.applicationId,
                    urlParams: {
                        review: false,
                    }
                })
                .then((result) => {
                    this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_COMMUNCATION_ADDRESS_DOCUMENT_UPLOAD, {
                        [this.$mixpanelPayload.RESPONSE]: result,
                        [this.$mixpanelPayload.JSON_PAYLOAD]: params,
                    });
                    resolve(result);
                })
                .catch((err) => {
                    this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_COMMUNCATION_ADDRESS_DOCUMENT_UPLOAD, {
                        [this.$mixpanelPayload.ERROR_REASON]: err.message,
                    });
                    reject(err);
                    this.isSpinLoading = false;
                });
            });
        },
        pdfPasswordFun() {
            this.isSpinLoading = true;
            this.$store.dispatch("unlockPdfWithPassword", {
                file: this.storageDoc,
                password: this.pdfPasswordValue,
            })
            .then(({ unlockedFile }) => {
                this.isSpinLoading = true;
                const params = {
                    personalInfo: {
                        addressProof: {
                            docType: 'personal_address_proof',
                            docSubType: 'communication_address_document',
                        },
                    },
                };
                this.readFile(unlockedFile, params).then((result) => {
                    if (!result?.success) {
                        this.isSpinLoading = false;
                        this.errorPopupMessage = result;
                    } else {
                        this.isSpinLoading = false;
                        this.submitApplication();
                    }
                })
                .catch((err) => {
                    this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_PASSWORD_PDF_ERROR, {
                        [this.$mixpanelPayload.RESPONSE]: err,
                        [this.$mixpanelPayload.KEY_MESSAGE]: 'Password protected PDF error in bank statement upload',
                    });
                    this.isSpinLoading = false;
                });
            })
            .catch((err) => {
                this.isSpinLoading = false;
                this.$moshaToast(err.message, {
                    type: "danger",
                    showIcon: true,
                });
            });
        },
        SubmitConfirmDetails() {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_PERSONAL_ADDRESS_CONFIRM_DETAILS_CLICKED, {
                [this.$mixpanelPayload.M_CODE]: 'check box unchecked false',
            });
            this.isSpinLoading = true;
            if (this.isPdfPasswordProtected) {
                this.pdfPasswordFun();
            } else {
                const params = {
                    personalInfo: {
                        addressProof: {
                            docType: 'personal_address_proof',
                            docSubType: 'communication_address_document',
                        },
                    },
                };
                this.readFile(this.storageDoc, params).then((result) => {
                    if (!result?.success) {
                        this.isSpinLoading = false;
                        this.errorPopupMessage = result;
                    } else {
                        this.isSpinLoading = false;
                        this.submitApplication();
                    }
                })
                .catch(() => {
                    this.isSpinLoading = false;
                });
            }
        }
    },
  };
  </script>
